import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import asObject from 'utils/objects/asObject.util';

const fromActionToFtag = (action) => `${fromAnyToTrimmed(asObject(action).type)}()`;

export default fromActionToFtag;
